import { useEffect, useState } from 'react';
import api from '../services/api';

let metaCache = null;
let pending = null;

/** Backend settings the UI depends on (face scan on/off, tax rate, demo engagement reachable). */
export default function useMeta() {
  const [meta, setMeta] = useState(metaCache);
  useEffect(() => {
    if (metaCache) return undefined;
    let alive = true;
    pending = pending || api.meta();
    pending
      .then((m) => {
        metaCache = m;
        if (alive) setMeta(m);
      })
      .catch(() => {
        pending = null;
      });
    return () => {
      alive = false;
    };
  }, []);
  return meta;
}
